module.exports = __webpack_public_path__ + "static/media/git-icon.736e0d37.svg";